export enum ImageSizes {
    ProductThumbnail = "140x140",
    ProductMain = "576x413"
}